import { request } from "../../../request";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Input, message, Modal, Popconfirm } from "antd";

import ICON_EDIT from "../../assets/edit.svg";
interface TypeEditPersonalSiteUrlProps<T = string> {
  value?: T;
  onChange?(value: T): void;
}

// 允许字母、数字和连字符，但严禁连字符(-)出现在首尾，且严禁出现连续的连字符(--)
const URL_CHECK = /^(?!.*--)[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

/**
 * @name EditPersonalSiteUrl 自定义 “Personal site” url
 */
const EditPersonalSiteUrl: React.FC<TypeEditPersonalSiteUrlProps> = ({
  value,
  onChange,
}) => {
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [customizeSlug, setCustomizeSlug] = useState<string>();

  const [org, slug] = useMemo(
    () => value?.split?.("/")?.splice?.(1) || [],
    [value],
  );

  useEffect(() => {
    open && slug && setCustomizeSlug(slug);
  }, [open, slug]);

  async function onSubmit() {
    if (customizeSlug) {
      const LandingUrl = `/${org}/${customizeSlug}`;
      if (!URL_CHECK.test(customizeSlug)) {
        return message.warning(
          "Please use only alphanumeric characters and hyphens (-). Multiple consecutive hyphens (--) and starting or ending with a hyphen (-) are not allowed.",
        );
      }
      if (LandingUrl.length > 64) {
        return message.warning(
          `The url (${LandingUrl}) you have entered exceeds the maximum limit of 64 bits, please re-enter it`,
        );
      }
      try {
        setLoading(true);
        // 只有发生变化才去更新
        if (LandingUrl !== value) {
          await request(`/los/updatelandingurl`, {
            method: "POST",
            body: { LandingUrl },
            isSuccess: (res) => res.status === 200,
          });
          onChange?.(LandingUrl);
        }
        onCancel();
      } catch (e) {
        console.log("@-err", e);
      } finally {
        setLoading(false);
      }
    } else {
      message.error("Please enter the correct address");
    }
  }

  function onCancel() {
    setCustomizeSlug(undefined);
    setOpen(false);
  }

  async function onRequest() {
    try {
      setLoading(true);
      await request("/los/changedomainrequest");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  function onOpen() {
    setOpen(true);
  }

  return (
    <>
      <img onClick={onOpen} src={ICON_EDIT} />
      <Modal
        centered
        open={open}
        width={730}
        onOk={onSubmit}
        okText="Publish"
        onCancel={onCancel}
        okButtonProps={{ disabled: loading }}
        title="Configure your personal website"
        cancelButtonProps={{ disabled: loading }}
        className="layout-modal layout-modal-no-borer layout-form-data website-edit-personal-site-url"
      >
        <p>Set your website address to publish and access your site.</p>
        <div>
          <Input value={`${window.location.origin}/${org}/`} />
          <span>+</span>
          <Input
            value={customizeSlug}
            onChange={(e) => setCustomizeSlug(e.target.value)}
          />
        </div>
        <Popconfirm
          onConfirm={onRequest}
          okText="Submit request"
          okButtonProps={{ loading }}
          title={
            <div style={{ maxWidth: 250 }}>
              Would you like to submit a request to customize the domain for
              your personal website?
            </div>
          }
        >
          <Button type="link">Customize the URL</Button>
        </Popconfirm>
      </Modal>
    </>
  );
};

export default EditPersonalSiteUrl;
